import dJSON from 'dirty-json';

/**
 * Projects Data
 */
document.querySelectorAll('.js-side-slider').forEach((item) => {
  const projectsData = item.data;
  let arr = '';
  let nActive = 'nActive';
  let tabIndex = 'tabindex="0"';
  const data = dJSON.parse(projectsData);

  Object.keys(data).forEach((key) => {
    const entry = data[key];
    const img = entry.image || 'https://eu.evocdn.io/dealer/1655/content/media/My_Theme/hg-hero-img-ph.jpg';
    const title = entry.title || 'Project Title';
    const text = entry.text || 'Project Text';
    const link = entry.link || '#';

    const htmlString = /* html */ `
    <a class="side-slide ${nActive}" href="${link}" ${tabIndex}>
      <img src="${img}" alt="">
      <div class="nOverlay">
        <h2 class="text-white">${title}</h2>
        <p>${text}</p>
      </div>              
    </a>
    `;

    if (nActive) {
      nActive = '';
      tabIndex = 'tabindex="-1"';
    }

    arr += htmlString;
  });

  item.querySelector('.slides-wrap').innerHTML = arr;
  item.querySelector('script').remove();
});

/**
 * Side Slider Init
 */
(() => {
  document.querySelectorAll('.js-side-slider').forEach((item) => {
    item.querySelector('.side-slide:first-child').classList.add('nActive');

    item.querySelectorAll('.nav-arrow').forEach((navArrow) => {
      const slideSlider = (e) => {
        const arrow = e.currentTarget;
        if (arrow.classList.contains('disabled')) return;

        arrow.classList.add('disabled');
        setTimeout(() => {
          arrow.classList.remove('disabled');
        }, 350);

        const wrapper = item.querySelector('.slides-wrap');
        const currentLeft = parseInt(wrapper.style.marginLeft.replace(/[^-\d.]/g, ''), 10) || 0;
        let moveAmount = wrapper.querySelector('.side-slide').offsetWidth;
        let gap = parseInt(getComputedStyle(wrapper).gap.replace(/[^-\d.]/g, ''), 10);

        // safari bug - gap will return duplicate eg "1818" instead of "18"
        // quick fix to force it to 18 if over 100
        if (gap > 100) {
          gap = 18;
        }

        let direction = 'prev';
        if (navArrow.classList.contains('nav-next')) {
          moveAmount *= -1;
          gap *= -1;
          direction = 'next';
        }

        const moveTo = currentLeft + moveAmount + gap;

        const activeSlide = wrapper.querySelector('.nActive');

        if (direction === 'next') {
          if (activeSlide.nextElementSibling) {
            activeSlide.classList.remove('nActive');
            activeSlide.setAttribute('tabindex', '-1');
            activeSlide.nextElementSibling.classList.add('nActive');
            activeSlide.nextElementSibling.setAttribute('tabindex', '0');
            wrapper.style.marginLeft = `${moveTo}px`;
          } else {
            wrapper.style.marginLeft = `${currentLeft - 30}px`;
            setTimeout(() => {
              wrapper.style.marginLeft = `${currentLeft}px`;
            }, 150);
          }
        }

        if (direction === 'prev') {
          if (activeSlide.previousElementSibling) {
            activeSlide.classList.remove('nActive');
            activeSlide.setAttribute('tabindex', '-1');
            activeSlide.previousElementSibling.classList.add('nActive');
            activeSlide.previousElementSibling.setAttribute('tabindex', '0');
            wrapper.style.marginLeft = `${moveTo}px`;
          } else {
            wrapper.style.marginLeft = `${currentLeft + 30}px`;
            setTimeout(() => {
              wrapper.style.marginLeft = `${currentLeft}px`;
            }, 150);
          }
        }
      };

      navArrow.addEventListener('click', (e) => {
        slideSlider(e);
      });

      navArrow.addEventListener('keyup', (e) => {
        if (!(e.key === 'Enter')) return;
        slideSlider(e);
      });
    });
  });
})();
